var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "el-button",
        {
          staticClass: "hq-button",
          attrs: { disabled: _vm.disabled, type: "primary" },
          on: {
            click: function($event) {
              _vm.modalShow = true
            }
          }
        },
        [_vm._v("变更" + _vm._s(_vm.title))]
      ),
      _c(
        "HqModal",
        {
          attrs: {
            visible: _vm.modalShow,
            title: "变更" + _vm.title,
            width: "400"
          },
          on: { "on-cancel": _vm.cancel }
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.formRules } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.currCol.teacherName || "--",
                              label: "原" + _vm.title + "老师",
                              "hide-details": "auto",
                              outlined: "",
                              readonly: "",
                              dense: true,
                              height: 32
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.teacherList,
                              "menu-props": { bottom: true, offsetY: true },
                              label: "变更为",
                              "item-text": "userName",
                              "item-value": "ncUserPk",
                              outlined: "",
                              dense: true,
                              height: 32,
                              clearable: true,
                              "clear-icon": "$clear",
                              "hide-details": "auto",
                              "no-data-text": "暂无数据"
                            },
                            model: {
                              value: _vm.form.teacherPk,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "teacherPk", $$v)
                              },
                              expression: "form.teacherPk"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }